export default "__VITE_ASSET__BY64xAvr__"